import type { CategoryCardType } from '@/types'

export const statistics: CategoryCardType[] = [
  {
    id: 1,
    imgCard: '/assets/info/total.png',
    price: 1400,
    priceColor: '#FFFFFF',
    prefix: '$',
    title: 'Bets',
  },
  {
    id: 2,
    imgCard: '/assets/info/win_2.png',
    price: 2400,
    priceColor: '#2CEA65',
    title: 'Wins',
  },
  {
    id: 3,
    imgCard: '/assets/info/lose_2.png',
    price: 206,
    priceColor: '#FF4A53',
    title: 'Loses',
  },
  {
    id: 4,
    imgCard: '/assets/info/wagered.png',
    price: 456200,
    priceColor: '#FFFFFF',
    prefix: '$',
    title: 'Wagered',
  },
]
